export const ADD_TO_CART = 'innovA/cart#addToCart';
export const REMOVE_FROM_CART = 'innovA/cart#removeFromCart';
export const INCREMENT_QTY = 'innovA/cart#incrementQty';
export const DECREMENT_QTY = 'innovA/cart#decrementQty';
export const CALCULATE_TOTAL = 'innovA/cart#calculateTotal';
export const UPDATE_CART_STATE = 'innovA/cart#updateCartState';
